import { DateTime } from 'luxon'

export const dateTimeToAlgolia = (dateTime: DateTime) =>
  dateTime.toMillis() / 1000
